export const rubrosHistoricos = [
    {
        "anio" : "2026",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSESA/zip/2026/PRIMER TRIMESTRE SESA 2026.zip"
            },
        ]
    },
    {
        "anio" : "2025",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSESA/zip/2025/PRIMER TRIMESTRE SESA 2025.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/TransparenciaSESA/zip/2025/SEGUNDO TRIMESTRE SESA 2025.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/TransparenciaSESA/zip/2025/TERCER TRIMESTRE SESA 2025.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/TransparenciaSESA/zip/2025/CUARTO TRIMESTRE SESA 2025.zip"
            },
        ]
    },
    {
        "anio" : "2024",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSESA/zip/2024/PRIMER TRIMESTRE SESA 2024.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/TransparenciaSESA/zip/2024/SEGUNDO TRIMESTRE SESA 2024.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/TransparenciaSESA/zip/2024/TERCER TRIMESTRE SESA 2024.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/TransparenciaSESA/zip/2024/CUARTO TRIMESTRE SESA 2024.zip"
            }
        ]
    },
    {
        "anio" : "2023",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSESA/zip/2023/PRIMER TRIMESTRE SESA 2023.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/TransparenciaSESA/zip/2023/SEGUNDO TRIMESTRE SESA 2023.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/TransparenciaSESA/zip/2023/TERCER TRIMESTRE SESA 2023.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/TransparenciaSESA/zip/2023/CUARTO TRIMESTRE SESA 2023.zip"
            }
            
        ]
    },
    {
        "anio" : "2022",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSESA/zip/2022/PRIMER TRIMESTRE SESA 2022.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/TransparenciaSESA/zip/2022/SEGUNDO TRIMESTRE SESA 2022.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/TransparenciaSESA/zip/2022/TERCER TRIMESTRE SESA 2022.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/TransparenciaSESA/zip/2022/CUARTO TRIMESTRE SESA 2022.zip"
            }
        ]
    },
    {
        "anio" : "2021",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSESA/zip/2021/PRIMER TRIMESTRE SESA 2021.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/TransparenciaSESA/zip/2021/SEGUNDO TRIMESTRE SESA 2021.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/TransparenciaSESA/zip/2021/TERCER TRIMESTRE SESA 2021.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/TransparenciaSESA/zip/2021/CUARTO TRIMESTRE SESA 2021.zip"
            }
        ]
    },
    {
        "anio" : "2020",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSESA/zip/2020/PRIMER TRIMESTRE SESA 2020.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/TransparenciaSESA/zip/2020/SEGUNDO TRIMESTRE SESA 2020.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/TransparenciaSESA/zip/2020/TERCER TRIMESTRE SESA 2020.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/TransparenciaSESA/zip/2020/CUARTO TRIMESTRE SESA 2020.zip"
            }
        ]
    },
    {
        "anio" : "2019",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSESA/zip/2019/PRIMER TRIMESTRE SESA 2019.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/TransparenciaSESA/zip/2019/SEGUNDO TRIMESTRE SESA 2019.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/TransparenciaSESA/zip/2019/TERCER TRIMESTRE SESA 2019.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/TransparenciaSESA/zip/2019/CUARTO TRIMESTRE SESA 2019.zip"
            }
        ]
    },
    {
        "anio" : "2018",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSESA/zip/2018/PRIMER TRIMESTRE SESA 2018.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/TransparenciaSESA/zip/2018/SEGUNDO TRIMESTRE SESA 2018.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/TransparenciaSESA/zip/2018/TERCER TRIMESTRE SESA 2018.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/TransparenciaSESA/zip/2018/CUARTO TRIMESTRE SESA 2018.zip"
            }
        ]
    },
    {
        "anio" : "2015 - 2017",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Plataforma Nacional",
                "url" : "https://consultapublicamx.inai.org.mx/vut-web/?idSujetoObigadoParametro=2131&idEntidadParametro=13&idSectorParametro=21"
            }
        ]
    },
    {
        "anio" : "Información Histórica 21 Rubros",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Descargar",
                "url" : "/TransparenciaSESA/zip/historico21rubros.zip"
            }
        ]
    }
]